import { Button, Col, Flex, Row } from "antd";
import { CustomTable, FilterCol, HeaderRow } from "./StyledComponent";
import { useSeriesHooks } from "./hooks/useSeriesHooks";
import React, { FC, Fragment, useState } from "react";
import AddSeriesForm from "./modals/AddSeriesForm";
import { ComponentTitle } from "../custom-components";
import { TabComponentProps } from "../utils/common.interface";
import useScreenSizeHook from "../utils/useScreenSizeHook";
import Filters from "./filters";

const Series: FC<TabComponentProps> = () => {
	const { height, width } = useScreenSizeHook();
	const {
		editId,
		columnSeries,
		seriesData,
		isLoading,
		setIsLoading,
		saveSeriesData,
		isAddSeriesFormOpen,
		setIsSeriesFormOpen,
		form,
		handleCancel,
		editHelper,
		pagination,
		handleTableChange,
		ratings,
		exportSeriesData,
		languagesList,
		seriesMultipleItems,
		setMultipleSeriesItems,
	} = useSeriesHooks();

	const [filteredTable, setFilteredTable] = useState(seriesData);

	return (
		<Fragment>
			<Row justify="space-between" align="middle">
				<Col xs={24} sm={24} md={3} lg={4} xl={4}>
					<ComponentTitle>Series</ComponentTitle>
				</Col>
				<FilterCol xs={24} sm={24} md={13} lg={16} xl={16} width={width}>
					<Filters setFilteredTable={setFilteredTable} />
				</FilterCol>
				<Col xs={24} sm={24} md={4} lg={4} xl={4}>
					<Flex gap={8} align="middle" justify={`${width < 800 ? "start" : "end"}`}>
						<Button onClick={exportSeriesData}>Export</Button>
						<Button onClick={() => setIsSeriesFormOpen(true)}>+ Add Series</Button>
					</Flex>
				</Col>
			</Row>
			<CustomTable
				key={'series-table'}
				onChange={handleTableChange}
				columns={columnSeries}
				dataSource={filteredTable}
				scroll={{ y: height - 260 }}
				pagination={pagination}
				loading={isLoading}
				rowKey={record => record.id}
				onRow={(record: any) => {
					return {
						onClick: () => {
							editHelper(record);
						},
					};
				}}
			/>
			<AddSeriesForm
				editId={editId}
				form={form}
				isAddSeriesFormOpen={isAddSeriesFormOpen}
				saveSeriesData={saveSeriesData}
				isLoading={isLoading}
				setIsLoading={setIsLoading}
				handleCancel={handleCancel}
				ratings={ratings}
				languagesList={languagesList}
				seriesMultipleItems={seriesMultipleItems}
				setMultipleSeriesItems={setMultipleSeriesItems}
			/>
		</Fragment>
	);
};

export default Series;
